export default __webpack_public_path__ + "img/waveedge-simulation-lab.04436c68.png";